import styled from 'styled-components';
import { themes } from 'kb-shared';

const { colors, fonts, fontSizes } = themes;

export const TextField = styled.input`
  background: transparent;
  border: none;
  grid-area: name;
  ${fonts.DomaineDisplay};
  ${fontSizes['24']};

  ::placeholder,
  ::-webkit-input-placeholder {
    ${fonts.DomaineDisplay};
    color: ${colors.KBLightBlueGrey};
  }
  :-ms-input-placeholder {
    ${fonts.DomaineDisplay};
    color: ${colors.KBLightBlueGrey};
  }
`;
